import { useEffect, useState } from "react";
import { API_BASE } from "@/lib/apiClient";
import type { TicketAttachment } from "@/types/supportTicket";

function mediaUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  if (!API_BASE) return path;
  return `${API_BASE}${path.startsWith("/") ? "" : "/"}${path}`;
}

export function TicketMessageImages({ attachments }: { attachments: TicketAttachment[] }) {
  const images = attachments.filter((att) => (att.content_type || "").toLowerCase().startsWith("image/"));
  const imageKey = images.map((att) => `${att.id}:${att.url}`).join("|");
  const [loaded, setLoaded] = useState<{ id: string; url: string; filename: string }[]>([]);

  useEffect(() => {
    let cancelled = false;
    const created: string[] = [];
    setLoaded([]);
    if (!imageKey) return undefined;

    void (async () => {
      const next: { id: string; url: string; filename: string }[] = [];
      for (const att of images) {
        try {
          const response = await fetch(mediaUrl(att.url), { credentials: "include" });
          if (!response.ok) continue;
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          created.push(url);
          next.push({ id: att.id, url, filename: att.filename });
        } catch {
          /* Die Antwort bleibt ohne dieses Bild sichtbar. */
        }
      }
      if (!cancelled) setLoaded(next);
    })();

    return () => {
      cancelled = true;
      for (const url of created) URL.revokeObjectURL(url);
    };
    // imageKey bildet die Anhänge ab.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageKey]);

  if (!loaded.length) return null;

  return (
    <ul className="mt-2 flex list-none flex-wrap gap-2 p-0">
      {loaded.map((image) => (
        <li key={image.id}>
          <img
            src={image.url}
            alt={image.filename}
            className="max-h-40 rounded-lg border border-separator bg-fill-quaternary"
          />
        </li>
      ))}
    </ul>
  );
}
